
import CartComponent from "../components/cart/CartComponent";

const Cart = () => {
  return(
  <>
   <CartComponent />
  </>
  )  
}

export default Cart;











